module.exports = __webpack_public_path__ + "img/icon-activity-orange.649d3aa7.png";